var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppleHideEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 108,
  height: 77,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#AppleHideEmail_svg__a)",
  fillRule: "evenodd",
  d: "M5.551 2.247A12.74 12.74 0 0 1 12.796 0H77.29c2.663 0 5.137.814 7.185 2.206L46.35 40.331a1.92 1.92 0 0 1-2.714 0zM57.18 34.931l11.793 11.513v-2.631c0-3.155 1.898-6 4.812-7.21l13.062-5.423a7.8 7.8 0 0 1 3.24-.593v-17.79c0-3.019-1.045-5.793-2.793-7.98zm-2.715 2.715 14.508 14.163v10.34c0 2.035.794 3.972 2.184 5.415h-58.36c-2.304 0-4.465-.609-6.333-1.674l28.995-28.307 5.463 5.463a5.76 5.76 0 0 0 8.143 0zm-21.721-2.778L3.429 63.486A12.75 12.75 0 0 1 0 54.768V12.796c0-2.992 1.027-5.744 2.748-7.923zm55.33-.734a4.6 4.6 0 0 1 3.495-.015l13.426 5.437a4.61 4.61 0 0 1 2.878 4.27v18.307a4.6 4.6 0 0 1-1.897 3.726l-13.42 9.76a4.61 4.61 0 0 1-5.464-.032L74.023 65.84a4.6 4.6 0 0 1-1.852-3.692V43.813c0-1.862 1.12-3.54 2.84-4.255zm14.681 27.739-12.797 9.306v-32.19l12.797 5.182z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "AppleHideEmail_svg__a",
  x1: 90.085,
  x2: 90.021,
  y1: 12.412,
  y2: 76.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0054C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7CB3FF"
})))));
export { SvgAppleHideEmail as ReactComponent };
export default "https://static.web-purchase.prod.moonpig.net/c53103bcb94ab5f1e664fb453f449eb532b3642b/_next/static/images/AppleHideEmail-b4161dbacb3f23ee912aefd278fb5337.svg";